<template>
  <b-container fluid class="vehicle-details">
    <b-row class="vehicle-detail-label-row">
      <b-col class="col-6"><span class="vehicle-detail-item-label">battery</span></b-col>
      <b-col class="col-6"><span class="vehicle-detail-item-label">odometer</span></b-col>
    </b-row>
    <b-row class="vehicle-detail-item-row">
      <b-col class="col-6"><span class="vehicle-detail-item"><strong><span>L {{typeof this.vehicle.batTwoSoc === "number" ? this.vehicle.batTwoSoc : "N/A"}}%</span><span style="margin-left:5px;">R {{typeof this.vehicle.batOneSoc === "number" ? this.vehicle.batOneSoc : "N/A"}}%</span></strong></span></b-col>
      <b-col class="p-0 vehicle-detail-divider"></b-col>
      <b-col class="col"><span class="vehicle-detail-item">{{Math.round(this.vehicle.odometer * 10) / 10}}km</span></b-col>
    </b-row>
    <b-row class="vehicle-actions-row">
      <b-col><b-button class="cm-btn" :disabled="processingCommand" variant="light" block @click="openBatteryDoor(vehicle.id)">open lid</b-button></b-col>
    </b-row>
  </b-container>
</template>

<script>

  import axios from 'axios';
  import { firebaseAuth } from "@/firebase";

  export default {
    name: "VehicleDetailsBar",
    props: {
      vehicle: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        processingCommand: false,
        range: null
      }
    },
    methods: {
      startScooter(id) {
        return this.sendCommand("START", id);
      },
      stopScooter(id) {
        return this.sendCommand("STOP", id);
      },
      openBatteryDoor(id) {
        return this.sendCommand("OPEN_BAT_DOOR", id);
      },
      async sendCommand(command, vehicleId) {
        this.processingCommand = true;
        let authToken = await firebaseAuth.currentUser.getIdToken();
        try {
          await axios.post(
              `https://europe-west3-coscooter-eu-staging.cloudfunctions.net/send-commands?apiKey=${authToken}`,
              { command, vehicleId }
          );
        } catch (e) {
          this.processingCommand = false;
        }
        this.processingCommand = false;
      }
    }
  }
</script>

<style scoped>
  .vehicle-details {
    background-color: rgba(255, 255, 255, 1);
    position: fixed;
    height: auto;
    width: 100%;
    bottom: 0;
    border-radius: 20px;
  }
  .vehicle-detail-item-row {
    margin-bottom: 25px;
    margin-top: 3px;
  }
  .vehicle-detail-item {
    color: rgba(173,175,181,1);
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-family: Muli;
  }
  .vehicle-detail-label-row {
    margin-top: 25px;
  }
  .vehicle-detail-item-label {
    color: rgba(21,23,28,1);
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-family: Muli;
  }
  .vehicle-detail-divider {
    border-left-color: rgba(237,237,242,1);
    fill: transparent;
    border-left-width: 2px;
    border-left-style: solid;
    flex: 0 0 2px;
    margin-left: -2px;
  }
  .vehicle-actions-row {
    margin: 0 0 29px 0;
  }
  .cm-btn {
    background-color: rgba(255,255,255,1);
    box-shadow: 3px 4px 16px rgba(0,0,0,0.098);
    border: 1px solid rgba(237, 237, 242, 1);
    border-radius: 12px;
    height: 46px;
    stroke: rgba(237,237,242,1);
    stroke-width: 1px;
    stroke-linejoin: miter;
    stroke-linecap: butt;
    stroke-miterlimit: 4;
    shape-rendering: auto;
    box-sizing: border-box;
    font-size:15px;
    font-weight: bold;
    font-family: Muli;
    color: rgba(0,0,0,1);
  }
  .cm-btn:hover {
    background-color: rgba(255,255,255,1);
  }
  .cm-btn:active {
    background-color: rgba(173,175,181,1);
  }
  .cm-btn:disabled {
    background-color: rgba(173,175,181,1);
  }
</style>
